import { Injectable } from '@angular/core';

import { NOT_APPLICABLE, TrackData, TrackingService, trackingConstants } from '@frontend/sports/tracking/feature';

import { MyBetsTrackingConstants, MyBetsTrackingData } from '../models';

@Injectable()
export class MyBetsTrackingService {
    constructor(private trackingService: TrackingService) {}

    private getTrackingMyBetsEventsInfo(trackingData: MyBetsTrackingData): Partial<TrackData> {
        return {
            [trackingConstants.COMPONENT_CATEGORY_EVENT]: MyBetsTrackingConstants.CategoryEvent,
            [trackingConstants.COMPONENT_LABEL_EVENT]: MyBetsTrackingConstants.MyBets,
            [trackingConstants.COMPONENT_ACTION_EVENT]: trackingData.action,
            [trackingConstants.COMPONENT_POSITION_EVENT]: NOT_APPLICABLE,
            [trackingConstants.COMPONENT_LOCATION_EVENT]: MyBetsTrackingConstants.MyBets,
            [trackingConstants.COMPONENT_EVENT_DETAILS]: MyBetsTrackingConstants.MyBets,
            [trackingConstants.COMPONENT_URL_CLICKED]: NOT_APPLICABLE,
        };
    }

    trackMyBetsCTAClose(trackingData: MyBetsTrackingData): void {
        this.trackingService.track(trackingConstants.EVENT_TRACKING, this.getTrackingMyBetsEventsInfo(trackingData));
    }
}
